/* Reuse Junip's real, already-loaded source; no copied aggregate metafields. */
(() => {
  let queued=false;
  function normalise() {
    queued=false;
    document.querySelectorAll('[data-zm-shared-review]:not([data-review-count]),[data-zm-shared-pdp-review]:not([data-shared-ready])').forEach(root=>{
      const widget=root.querySelector('.junip-product-summary');
      if(!widget || widget.dataset.productId!==root.dataset.reviewSourceId)return;
      const label=widget.querySelector('.junip-product-summary-star-ratings-container')?.getAttribute('aria-label') || '';
      const match=label.match(/([\d.]+)\s+stars?,\s*([\d,]+)\s+reviews?/i);
      if(!match)return;
      const rating=Number(match[1]), count=Number(match[2].replace(/,/g,''));
      if(!(rating>0 && rating<=5 && Number.isInteger(count) && count>0))return;
      if(root.hasAttribute('data-zm-shared-pdp-review')){
        root.hidden=false;root.dataset.sharedReady='true';return;
      }
      const fraction=rating%1;
      const rounded=Math.floor(rating)+(fraction>=.3&&fraction<=.7?.5:fraction>.7?1:0);
      const stars=document.createElement('span');
      stars.className='zm-c13-rating__stars';stars.setAttribute('aria-hidden','true');
      for(let i=0;i<5;i++){
        const star=document.createElement('span');star.className='zm-c20-star';star.textContent='★';
        star.style.setProperty('--zm-star-fill',Math.max(0,Math.min(100,(rounded-i)*100))+'%');
        stars.append(star);
      }
      const number=document.createElement('span');number.className='zm-c13-rating__count';
      number.setAttribute('aria-hidden','true');number.textContent='('+count+')';
      root.dataset.reviewCount=String(count);root.dataset.reviewRating=String(rating);
      root.setAttribute('aria-label',rating+' out of 5 stars, '+count+' customer reviews for this scent (perfume oil reviews)');
      root.replaceChildren(stars,number);
    });
  }
  function schedule(){if(!queued){queued=true;requestAnimationFrame(normalise)}}
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  schedule();
})();
